import React from "react";

const FinalizePopUp = props => {
  return (
    <div className="fixedPopUp">
      <div className="confirmDeliveryPopUp">
        <h1>Confirm payment of load (finalize)</h1>
        <div className="btnRow">
          <div className="btnRowFiller"></div>
          <div onClick={() => props.toggle(8)} className="cancelBtn">
            Cancel
          </div>
          <div
            onClick={() => (props.markFinished(props.load), props.toggle(8))}
            className="postBtn"
          >
            Confirm
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinalizePopUp;
